import request from "../request";
import {
  REACT_BASE_URL_GAMA_VEHICLES,
  REACT_BASE_URL_GAMA_SHAREPOINT,
} from "../url";

export const getInvoices = (
  year,
  month,
  state,
  nOrderOrCompany = undefined,
  query,
) => {
  const params = {
    year,
    month,
  };

  if (nOrderOrCompany) {
    params.nOrderOrCompany = nOrderOrCompany;
  }

  if (state) {
    params.state = state;
  }

  console.log(params, "params", query, "query");

  return request({
    url:
      `${REACT_BASE_URL_GAMA_VEHICLES}/invoice?pageSize=${
        query?.pageSize || 7
      }&page=${query?.currentPage || 1}&orderByProperty=${
        query?.orderByProperty || "fecha_emision_factura"
      }&orderBy=${query?.orderBy || "DESC"}&` +
      new URLSearchParams(params).toString(),
    method: "GET",
  });
};

export const getDocument = (folder, subFolder, deviceId) => {
  const params = {
    folder,
    subFolder,
    deviceId,
  };

  console.log(params, "params");

  return request({
    url:
      `${REACT_BASE_URL_GAMA_SHAREPOINT}/documents/invoices?` +
      new URLSearchParams(params).toString(),
    method: "GET",
  });
};
